"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var aggregate_1 = __importDefault(require("./aggregate"));
exports.avg = function (value, alias) { return new aggregate_1.default('avg', value, alias); };
exports.collect = function (value, alias) { return new aggregate_1.default('collect', value, alias); };
exports.count = function (value, alias) { return new aggregate_1.default('count', value, alias); };
exports.max = function (value, alias) { return new aggregate_1.default('max', value, alias); };
exports.min = function (value, alias) { return new aggregate_1.default('min', value, alias); };
exports.percentileCont = function (value, alias) { return new aggregate_1.default('percentileCont', value, alias); };
exports.percentileDisc = function (value, alias) { return new aggregate_1.default('percentileDisc', value, alias); };
exports.stDev = function (value, alias) { return new aggregate_1.default('stDev', value, alias); };
exports.stDevP = function (value, alias) { return new aggregate_1.default('stDevP', value, alias); };
exports.sum = function (value, alias) { return new aggregate_1.default('sum', value, alias); };
